//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { ActiveSubscriptions } from './models/ActiveSubscriptions';
import type { AvailableCategoriesByNature } from './models/AvailableCategoriesByNature';
import type { AvailableSubscriptions } from './models/AvailableSubscriptions';
import type { FileResponse } from './models/FileResponse';
import type { GetSubscribersCountForProductsResponse } from './models/GetSubscribersCountForProductsResponse';
import type { GetUsersWithSubscriptionsRequest } from './models/GetUsersWithSubscriptionsRequest';
import type { GetUsersWithSubscriptionsResponse } from './models/GetUsersWithSubscriptionsResponse';
import { SearchStatus } from './models/SearchStatus';
import type { SearchSubscriptionResult } from './models/SearchSubscriptionResult';
import type { SubscriptionModel } from './models/SubscriptionModel';
import type { SubscriptionsHistoryResult } from './models/SubscriptionsHistoryResult';
import { Utilities } from './Utilities';

export class SearchSubscriptionsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
			icIds?: string,
			status?: SearchStatus,
			include?: string,
			categoryIds?: string,
			productIds?: string,
			sectorIds?: string,
			keywordIds?: string,
			companyIds?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions?';
            if (icIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('icIds'));
            } else if (icIds !== undefined) {
                clientRequestUrl += `icIds=${encodeURIComponent(String(icIds))}&`;
            }
            if (status === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('status'));
            } else if (status !== undefined) {
                clientRequestUrl += `status=${encodeURIComponent(String(status))}&`;
            }
            if (include === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('include'));
            } else if (include !== undefined) {
                clientRequestUrl += `include=${encodeURIComponent(String(include))}&`;
            }
            if (categoryIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('categoryIds'));
            } else if (categoryIds !== undefined) {
                clientRequestUrl += `categoryIds=${encodeURIComponent(String(categoryIds))}&`;
            }
            if (productIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('productIds'));
            } else if (productIds !== undefined) {
                clientRequestUrl += `productIds=${encodeURIComponent(String(productIds))}&`;
            }
            if (sectorIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('sectorIds'));
            } else if (sectorIds !== undefined) {
                clientRequestUrl += `sectorIds=${encodeURIComponent(String(sectorIds))}&`;
            }
            if (keywordIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('keywordIds'));
            } else if (keywordIds !== undefined) {
                clientRequestUrl += `keywordIds=${encodeURIComponent(String(keywordIds))}&`;
            }
            if (companyIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('companyIds'));
            } else if (companyIds !== undefined) {
                clientRequestUrl += `companyIds=${encodeURIComponent(String(companyIds))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getUsersWithSubscriptions: (): string => {
            let clientRequestUrl = '/api/v1/subscriptions/do-get-users-with-subscriptions';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSubscribersByProductCount: (): string => {
            let clientRequestUrl = '/api/v1/subscriptions/count-for-products';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAvailable: (
			icId: string,
			categoryIds?: number[],
			productIds?: number[],
			sectorIds?: number[],
			keywordIds?: number[],
			status?: SearchStatus,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/available/{icId}?';
            if (icId === undefined || icId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('icId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent(String(icId)));
            if (categoryIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('categoryIds'));
            } else if (categoryIds !== undefined) {
                if (categoryIds) {
                    categoryIds.forEach(item => { clientRequestUrl += `categoryIds=${encodeURIComponent(String(item))}&`; });
                }
            }
            if (productIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('productIds'));
            } else if (productIds !== undefined) {
                if (productIds) {
                    productIds.forEach(item => { clientRequestUrl += `productIds=${encodeURIComponent(String(item))}&`; });
                }
            }
            if (sectorIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('sectorIds'));
            } else if (sectorIds !== undefined) {
                if (sectorIds) {
                    sectorIds.forEach(item => { clientRequestUrl += `sectorIds=${encodeURIComponent(String(item))}&`; });
                }
            }
            if (keywordIds === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('keywordIds'));
            } else if (keywordIds !== undefined) {
                if (keywordIds) {
                    keywordIds.forEach(item => { clientRequestUrl += `keywordIds=${encodeURIComponent(String(item))}&`; });
                }
            }
            if (status === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('status'));
            } else if (status !== undefined) {
                clientRequestUrl += `status=${encodeURIComponent(String(status))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAvailableCategories: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/available/{icId}/categories';
            if (icId === undefined || icId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('icId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent(String(icId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getActive: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/active/{icId}';
            if (icId === undefined || icId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('icId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent(String(icId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSubscriptionsHistory: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/history/{icId}';
            if (icId === undefined || icId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('icId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent(String(icId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getExport: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/history/{icId}/export';
            if (icId === undefined || icId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('icId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent(String(icId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        searchSubscriptions: (
			term?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/do-search?';
            if (term === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('term'));
            } else if (term !== undefined) {
                clientRequestUrl += `term=${encodeURIComponent(String(term))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves subscriptions.
     * @param icIds (optional) Get a list of subscriptions by the id of the contact.
    When the status is Active , it's limited to 1000.
    When the status is Available or IncludeInactive, it's limited to 1.
    Comma separated list of guid.
     * @param status (optional) A status, by default Active if not set
     * @param include (optional) A list of property to load additional data on the corresponding object.
    Available values: category, keyword, product, sector, company.
    Comma separated list of string.
     * @param categoryIds (optional) Get a list of subscriptions by the id of the category.
    Comma separated list of number.
     * @param productIds (optional) Get a list of subscriptions by the id of the product.
    Comma separated list of number.
     * @param sectorIds (optional) Get a list of subscriptions by the id of the sector.
    Comma separated list of number.
     * @param keywordIds (optional) Get a list of subscriptions by the id of the keyword.
    Comma separated list of number.
     * @param companyIds (optional) Get a list of subscriptions by the id of the company.
    Comma separated list of number.
     * @return OK
     */
    async get(
        icIds?: string,
        status?: SearchStatus,
        include?: string,
        categoryIds?: string,
        productIds?: string,
        sectorIds?: string,
        keywordIds?: string,
        companyIds?: string,
    ): Promise<SubscriptionModel[]> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
            icIds,
            status,
            include,
            categoryIds,
            productIds,
            sectorIds,
            keywordIds,
            companyIds,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SubscriptionModel[]>(_response, false, ['beginDate', 'endDate']);
    }

    /**
     * Get a list of user that have subscription given a list of IcId and a Status
     * @param body (optional) List of IcId and Status
     * @return OK
     */
    async getUsersWithSubscriptions(
        body?: GetUsersWithSubscriptionsRequest,
    ): Promise<GetUsersWithSubscriptionsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getUsersWithSubscriptions();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetUsersWithSubscriptionsResponse>(_response, false, []);
    }

    /**
     * Get subscriber's count for products
     * @return OK
     */
    async getSubscribersByProductCount(): Promise<GetSubscribersCountForProductsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getSubscribersByProductCount();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetSubscribersCountForProductsResponse>(_response, false, []);
    }

    /**
     * Get available subscriptions
     * @param categoryIds (optional) 
     * @param productIds (optional) 
     * @param sectorIds (optional) 
     * @param keywordIds (optional) 
     * @param status (optional) 
     * @return OK
     */
    async getAvailable(
        icId: string,
        categoryIds?: number[],
        productIds?: number[],
        sectorIds?: number[],
        keywordIds?: number[],
        status?: SearchStatus,
    ): Promise<AvailableSubscriptions> {
        const clientRequestUrl = this.baseUrl + this.routes.getAvailable(
            icId,
            categoryIds,
            productIds,
            sectorIds,
            keywordIds,
            status,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<AvailableSubscriptions>(_response, false, ['beginDate', 'endDate']);
    }

    /**
     * Get available categories for subscriptions
     * @return OK
     */
    async getAvailableCategories(
        icId: string,
    ): Promise<AvailableCategoriesByNature> {
        const clientRequestUrl = this.baseUrl + this.routes.getAvailableCategories(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<AvailableCategoriesByNature>(_response, false, []);
    }

    /**
     * Get active subscription
     * @return OK
     */
    async getActive(
        icId: string,
    ): Promise<ActiveSubscriptions> {
        const clientRequestUrl = this.baseUrl + this.routes.getActive(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ActiveSubscriptions>(_response, false, ['beginDate', 'endDate']);
    }

    /**
     * Get subscriptions history for a user
     * @return OK
     */
    async getSubscriptionsHistory(
        icId: string,
    ): Promise<SubscriptionsHistoryResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getSubscriptionsHistory(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SubscriptionsHistoryResult>(_response, false, ['beginDate', 'endDate']);
    }

    /**
     * Download subscriptions history export for a user
     * @return OK
     */
    async getExport(
        icId: string,
    ): Promise<FileResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getExport(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<FileResponse>(_response, true, []);
    }

    /**
     * Search subscriptions
     * @param term (optional) the term to search for
     * @return OK
     */
    async searchSubscriptions(
        term?: string,
    ): Promise<SearchSubscriptionResult[]> {
        const clientRequestUrl = this.baseUrl + this.routes.searchSubscriptions(
            term,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SearchSubscriptionResult[]>(_response, false, []);
    }
}
